import { tap, map, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { ReferralCommissionSetting } from '@core/models/referral-commission-setting.model';

@Injectable()
export class ReferralCommissionSettingsDataService extends DefaultDataService<ReferralCommissionSetting>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('ReferralCommissionSetting', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<ReferralCommissionSetting[]> {
    return this.http.get<ApiResponse>('/referralcommission/settings').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<ReferralCommissionSetting[]>{
    return this.http.get<ApiResponse>(`/referralcommission/settings${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  add(referralCommSetting: ReferralCommissionSetting): Observable<ReferralCommissionSetting>{
    return this.http.post<ApiResponse>(`/referralcommission/settings`, referralCommSetting).pipe(
      tap( res => this.messages$.next(res.message)),
      concatMap((entity) => this.http.get(`/referralcommission/settings/${entity.data.rows.setting.id}`).pipe(
        map((row: ApiResponse) => row.data.rows)
      ))
    );
  }

  updateReferralCommissionSetting(referralCommSetting: ReferralCommissionSetting){
    return this.http.put<ApiResponse>(`/referralcommission/settings/${referralCommSetting.id}`, referralCommSetting).pipe(
      tap( res => this.messages$.next(res.message))
    );
  }

  getById(id: number): Observable<ReferralCommissionSetting>{
    return this.http.get<ApiResponse>(`/referralcommission/settings/${id}`).pipe(
      map(res => {
        return {
          id: res.data.rows.setting.id,
          ...res.data.rows
        }
      })
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
